// Google map

const googleMapsKey = 'AIzaSyCtVLV2yHdQ_4Z79oUXVlN7GkrGNvqnDaQ';
const googleMapConfig = {
  center: { lat: 50.0755, lng: 14.4378 },
  zoom: 14,
}

class Map {
    static createMap() {
        var myMap = new google.maps.Map(gMapElement, googleMapConfig);
        return myMap;
    }
}

function initMap() {
    Map.createMap();
}
window.initMap = initMap;

const addGoogleMap = function (mapSelector) {
    document.addEventListener('DOMContentLoaded', function () {
        var mapElement = document.querySelector(mapSelector);
        if (mapElement) {
            window.gMapElement = mapElement;
            var js_file = document.createElement('script');
            js_file.type = 'text/javascript';
            js_file.src = 'https://maps.googleapis.com/maps/api/js?callback=initMap&key=' + googleMapsKey;
            document.getElementsByTagName('head')[0].appendChild(js_file);
        }
    });
}

export default addGoogleMap;
